import { SVGProps } from '../types';

const MaestroIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      stroke="#DEDBD4"
    />
    <path
      d="M16.8389 6.66669C21.72 6.66694 25.6768 10.6703 25.6768 15.6081C25.6765 20.5457 21.7198 24.5483 16.8389 24.5485C11.9577 24.5485 8.00021 20.5459 8 15.6081C8 10.6701 11.9576 6.66669 16.8389 6.66669Z"
      fill="#ED0006"
    />
    <path
      d="M28.3047 6.66669C33.1858 6.66694 37.1426 10.6703 37.1426 15.6081C37.1424 20.5457 33.1857 24.5483 28.3047 24.5485C23.4235 24.5485 19.466 20.5459 19.4658 15.6081C19.4658 10.6701 23.4234 6.66669 28.3047 6.66669Z"
      fill="#0099DF"
    />
    <path
      d="M22.5718 8.80554C24.4712 10.4454 25.6771 12.8833 25.6772 15.6073C25.6772 18.3313 24.471 20.7691 22.5718 22.4091C20.6725 20.7691 19.4663 18.3314 19.4663 15.6073C19.4664 12.8832 20.6723 10.4454 22.5718 8.80554Z"
      fill="#6C6BBD"
    />
  </svg>
);

export { MaestroIcon };
